import Swiper from "swiper";

import { Navigation, Pagination, Autoplay, Thumbs } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function swiperPropertyQuickView() {
    const thumbs = new Swiper(".property-quickView__thumbs", {
        slidesPerView: 3,
        spaceBetween: 12,
        loop: true,
        grabCursor: true,
        speed: 1000,
    });

    new Swiper(".property-quickView__swiper", {
        modules: [Navigation, Pagination, Autoplay, Thumbs],

        loop: true,
        grabCursor: true,
        speed: 800,

        navigation: {
            prevEl: ".property-quickView__swiper > .swiper-button-prev",
            nextEl: ".property-quickView__swiper > .swiper-button-next",
        },

        pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
        },

        thumbs: {
            swiper: thumbs,
        },

        /* Autoplay
         * https://swiperjs.com/swiper-api#autoplay
         */
        autoplay: {
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
            // delay: 500,
        },

        // Parallax
        watchSlidesProgress: true,
        on: {
            progress() {
                const swiper = this;

                const parallaxFactor = 0.5;
                const parallaxOffset = swiper.width * parallaxFactor;

                swiper.slides.forEach((slide) => {
                    const parallaxTranslate = slide.progress * parallaxOffset;
                    const parallaxElement = slide.firstElementChild;

                    if (parallaxElement) {
                        parallaxElement.style.transform = `translate3d(${parallaxTranslate}px, 0, 0)`;
                    }
                });
            },
        },
    });
}
